/**
 * Altar del Perfume — riel de perfumes similares.
 *
 * Es un custom element y no un script suelto porque el editor de temas desmonta y rearma la
 * sección: connected/disconnectedCallback son lo que impide que queden listeners colgados.
 *
 * No implementa el carrusel: el desplazamiento lo hace el navegador con scroll nativo, que ya
 * funciona con dedo, trackpad y shift+rueda. Lo único que agrega son las flechas para quien
 * navega con mouse, y apagarlas cuando no hay nada más hacia ese lado — una flecha que no lleva
 * a ningún lado es peor que no tenerla.
 */
class AltarRelated extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-altar-rail]');
    this.prev = this.querySelector('[data-altar-prev]');
    this.next = this.querySelector('[data-altar-next]');
    if (!this.rail) return;

    this.onPrev = () => this.move(-1);
    this.onNext = () => this.move(1);
    this.onScroll = () => this.sync();

    this.prev?.addEventListener('click', this.onPrev);
    this.next?.addEventListener('click', this.onNext);
    this.rail.addEventListener('scroll', this.onScroll, { passive: true });

    // El ancho del riel cambia al rotar el teléfono o al redimensionar, y con él cambia si
    // todavía queda algo por desplazar.
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(() => this.sync());
      this.observer.observe(this.rail);
    }

    this.sync();
  }

  disconnectedCallback() {
    this.prev?.removeEventListener('click', this.onPrev);
    this.next?.removeEventListener('click', this.onNext);
    this.rail?.removeEventListener('scroll', this.onScroll);
    this.observer?.disconnect();
  }

  move(direction) {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.rail.scrollBy({
      left: direction * this.rail.clientWidth * 0.8,
      behavior: reduce ? 'auto' : 'smooth',
    });
  }

  sync() {
    if (!this.rail) return;
    const max = this.rail.scrollWidth - this.rail.clientWidth;
    const x = this.rail.scrollLeft;
    // Un pixel de margen: los navegadores redondean scrollLeft y el extremo rara vez cae exacto.
    if (this.prev) this.prev.disabled = x <= 1;
    if (this.next) this.next.disabled = x >= max - 1;
    this.toggleAttribute('data-altar-static', max <= 1);
  }
}

if (!customElements.get('altar-related')) {
  customElements.define('altar-related', AltarRelated);
}
